import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item-box col" }
const _hoisted_5 = {
  key: 0,
  class: "activity-title"
}
const _hoisted_6 = { class: "activity-time flex spaced" }
const _hoisted_7 = {
  key: 1,
  class: "activity-time flex spaced"
}
const _hoisted_8 = { class: "activity-time flex spaced" }
const _hoisted_9 = { class: "activity-time flex spaced" }
const _hoisted_10 = { class: "row v-center gap spaced" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notify_box = _resolveComponent("notify-box")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_credit_card_payment_method = _resolveComponent("credit-card-payment-method")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exit(false)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fill row center h2" }, "Payment", -1))
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 0,
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isOrderPayment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "A payment is required to complete the reservation."))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.isOrderPayment ? 'Booking charges' : 'New time price difference'), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_si_currency, {
              amount: (_ctx.orderPayment?.SubTotal ?? 0) - _ctx.rescheduleFeeAmount
            }, null, 8, ["amount"])
          ])
        ]),
        (_ctx.rescheduleFeeAmount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("div", null, "Reschedule fee", -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_si_currency, { amount: _ctx.rescheduleFeeAmount }, null, 8, ["amount"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, "Taxes and Fees", -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_si_currency, {
              amount: _ctx.orderPayment?.TaxTotal ?? 0
            }, null, 8, ["amount"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[6] || (_cache[6] = _createElementVNode("div", null, "Amount due", -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_si_currency, {
              amount: _ctx.orderPayment?.PaymentAmount ?? 0
            }, null, 8, ["amount"])
          ])
        ])
      ]),
      (_ctx.orderPayment)
        ? (_openBlock(), _createBlock(_component_credit_card_payment_method, {
            key: 1,
            onCanSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.canSubmit = $event)),
            ref: "paymentMethod"
          }, null, 512))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
        _createVNode(_component_progress_button, {
          showLoader: _ctx.paymentLoading && _ctx.canSubmit,
          onOnClick: _ctx.onSubmitPayment,
          disabled: !_ctx.canSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _cache[7] || (_cache[7] = _createTextVNode("Pay ", -1)),
              _createVNode(_component_si_currency, { amount: _ctx.paymentAmount }, null, 8, ["amount"])
            ])
          ]),
          _: 1
        }, 8, ["showLoader", "onOnClick", "disabled"])
      ])
    ])
  ]))
}